import type { ReactNode } from "react";

type HubPageTitleProps = {
  readonly children: ReactNode;
  /** Optional control on the right (e.g. period select). */
  readonly trailing?: ReactNode;
};

/** Page heading for hub sections (no step numbering). */
export function HubPageTitle({ children, trailing }: HubPageTitleProps) {
  return (
    <header className={`nbs-hub-section__head${trailing ? " nbs-hub-section__head--row" : ""}`}>
      <div className="nbs-hub-section__title">
        <h2>{children}</h2>
      </div>
      {trailing}
    </header>
  );
}
